<template>
  <vs-popup
    title="Detalhes"
    :active.sync="isVisible"
    class="file-explorer-popup"
  >
    <div v-if="item" class="item-details">
      <div class="detail-row">
        <strong>Nome:</strong>
        <span>{{ item.name }}</span>
      </div>
      <div class="detail-row">
        <strong>Tipo:</strong>
        <span>{{
          item.type === 'directory'
            ? 'Pasta'
            : item.type === 'drive'
            ? 'Drive'
            : formatFileType(item)
        }}</span>
      </div>
      <div v-if="item.type === 'file'" class="detail-row">
        <strong>Tamanho:</strong>
        <span>{{ formatFileSize(item.size) }}</span>
      </div>
      <div class="detail-row">
        <strong>Proprietário:</strong>
        <span>{{ item.is_owner ? 'Eu' : item.owner_name || '--' }}</span>
      </div>
      <div v-if="item.modified" class="detail-row">
        <strong>Modificado:</strong>
        <span>{{ formatDate(item.modified) }}</span>
      </div>
    </div>
    <div class="footer-dialog justify-end">
      <div class="action-buttons">
        <slot name="footer-actions"></slot>
      </div>
      <b-button variant="outline-secondary" @click="close">
        <feather-icon icon="XIcon" size="16" class="mr-1" />
        Fechar
      </b-button>
    </div>
  </vs-popup>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import FeatherIcon from '@/components/FeatherIcon.vue'

export default {
  name: 'FileDetailsPopup',
  components: {
    BButton,
    FeatherIcon
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: null
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    close() {
      this.$emit('input', false)
    },

    formatFileSize(size) {
      if (!size) return 'Desconhecido'

      const units = ['B', 'KB', 'MB', 'GB', 'TB']
      let fileSize = size
      let unitIndex = 0

      while (fileSize >= 1024 && unitIndex < units.length - 1) {
        fileSize /= 1024
        unitIndex++
      }

      return `${fileSize.toFixed(1)} ${units[unitIndex]}`
    },

    formatDate(dateStr) {
      if (!dateStr) return 'Desconhecido'

      const date = new Date(dateStr)
      return date.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    },

    formatFileType(item) {
      if (item.type === 'directory') return 'Pasta'
      if (item.type === 'drive') return 'Drive'

      const extension = item.extension
        ? item.extension.toLowerCase()
        : item.name
        ? item.name
            .split('.')
            .pop()
            .toLowerCase()
        : ''

      switch (extension) {
        case 'pdf':
          return 'Documento PDF'
        case 'txt':
          return 'Arquivo de texto'
        case 'doc':
        case 'docx':
          return 'Documento Word'
        case 'xls':
        case 'xlsx':
          return 'Planilha Excel'
        case 'csv':
          return 'Arquivo CSV'
        case 'ppt':
        case 'pptx':
          return 'Apresentação PowerPoint'
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
        case 'svg':
        case 'webp':
          return 'Imagem'
        case 'mp3':
        case 'wav':
        case 'ogg':
        case 'flac':
          return 'Áudio'
        case 'mp4':
        case 'avi':
        case 'mov':
        case 'mkv':
        case 'webm':
          return 'Vídeo'
        case 'zip':
        case 'rar':
        case '7z':
        case 'tar':
        case 'gz':
          return 'Arquivo compactado'
        case 'html':
          return 'Página HTML'
        case 'css':
          return 'Estilo CSS'
        case 'js':
          return 'Script JavaScript'
        case 'ts':
          return 'Script TypeScript'
        case 'json':
          return 'Arquivo JSON'
        case 'xml':
          return 'Arquivo XML'
        default:
          return extension
            ? `Arquivo ${extension.toUpperCase()}`
            : 'Arquivo desconhecido'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.file-explorer-popup {
  .item-details {
    padding: 1rem;

    .detail-row {
      display: flex;
      margin-bottom: 0.5rem;

      strong {
        min-width: 100px;
        font-weight: 600;
      }

      span {
        flex: 1;
      }
    }
  }

  .footer-dialog {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    border-top: 1px solid #eee;

    .action-buttons {
      display: flex;
      gap: 0.5rem;
    }

    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
